import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

let subscriptions = [];

const HOST = process.env.REACT_APP_WEBHOST;
const SALT_VALUE = "srd6419^$!(";

const sha256 = (text) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  return crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  });
};

export const createControlSocket = (userId, onConnect) => {
  if (!userId || userId === "undefined") {
    console.warn("WebSocket not created: invalid userId", userId);
    return null;
  }

  const [, suffix = ""] = userId.split("_");
  if (!suffix) {
    console.warn("WebSocket not created: invalid suffix", userId);
    return null;
  }

  const client = new Client({
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,

    onConnect: () => {
      onConnect?.(client);
    },
  });

  sha256(`${suffix}${SALT_VALUE}`).then((hashedSuffix) => {
    const hashedUserId = `${hashedSuffix}`;
    client.webSocketFactory = () => new SockJS(`${HOST}/ws?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(hashedUserId)}`);
    client.activate();
  });

  return client;
};

export const resetSubscriptions = (
  client,
  {
    userId,
    bsdIds = [],
    subscribeMessages = false,
    subscribeGlobalAlarm = false,
    subscribeUserAlarm = false,
    subscribeBsdAlarm = false,
  },
  onMessage,
  onAlarm
) => {
  if (!client?.connected) return;

  subscriptions.forEach((sub) => {
    try {
      sub.unsubscribe();
    } catch (e) {
      // console.warn("unsubscribe fail", e);
    }
  });

  subscriptions = [];

  const safeParse = (body) => {
    try {
      return JSON.parse(body);
    } catch {
      return body;
    }
  };

  if (subscribeMessages) {
    subscriptions.push(
      client.subscribe("/topic/messages", (msg) => {
        onMessage?.(safeParse(msg.body));
      })
    );
  }

  if (subscribeGlobalAlarm) {
    subscriptions.push(
      client.subscribe("/topic/alarm", (msg) => {
        onAlarm?.(safeParse(msg.body));
      })
    );
  }

  if (subscribeUserAlarm) {
    subscriptions.push(
      client.subscribe("/user/queue/alarm", (msg) => {
        onAlarm?.(safeParse(msg.body));
      })
    );
  }

  if (subscribeBsdAlarm) {
    (bsdIds || []).forEach((bsdId) => {
      subscriptions.push(
        client.subscribe(
          `/queue/srdkorea/${bsdId}`,
          (msg) => {
            onAlarm?.(safeParse(msg.body));
          }
        )
      );
    });
  }
};
